import React from 'react';
import LabAnalysisOverviewCosts from '../LabAnalysisOverview/Costs/LabAnalysisOverviewCosts';
import { CurlyBraceDivider } from '/src/Components/CurlyBraceDivider/CurlyBraceDivider';

import { Scatter } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
} from 'chart.js';

// Register ChartJS components
ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);
import './style.css';

const LabAnalysisCosts = ({
    simulatorData,
    projectsList
}) => {
    // const colorWheel = ["#954BDB", "#53C7ED",  "#EDA153", "#53EDBF", "#688C98", "#EDC453", "#5D6E69", "#C3FCFD", "#F524BF", "#86C513", "#744687", "#1231C6", "#096750", "#95B396","#E24618", "#4390BE", "#78D8CC", "#4A6B73", "#450155", "#46E966"]
    

    const introText = `Home improvements are not just financial investments, there are also costs in time and disruption. Match the colors on the chart with the individual projects to see how each stacks up.`

    // Prepare data for scatter plot"
    const scatterData = {
        datasets: projectsList.map((project, index) => ({
            label: project.project_name,
            data: [{
                x: project.project_disruption * 10,
                y: project.project_complexity * 10
            }],
            backgroundColor: project.colorWheel,
            pointRadius: 6,
            pointStyle: 'circle',
            showLine: false,
            pointHoverRadius: 8
        }))
    };

    const fontStyles = {
        size: 12,
        weight: 'bold'
    }

    const options = {
        scales: {
            x: {
                min: 0,
                max: 11,
                title: {
                    display: true,
                    text: 'Disruption Level',
                    font: fontStyles
                },
                ticks: {
                    callback: function (value) {
                        if (value === 0) return '';
                        if (value === 5.5) return 'Med';
                        if (value === 11) return 'High';
                        return '';
                    },
                    stepSize: 5.5
                },
                grid: {
                    display: false
                }
            },
            y: {
                min: 0,
                max: 11,
                title: {
                    display: true,
                    text: 'Complexity Level',
                    font: fontStyles
                },
                ticks: {
                    callback: function (value) {
                        if (value === 0) return 'Low';
                        if (value === 5.5) return 'Med';
                        if (value === 11) return 'High';
                        return '';
                    },
                    stepSize: 5.5
                },
                grid: {
                    display: false
                }
            }
        },
        plugins: {
            legend: {
                display: false
            },
            tooltip: {
                titleFont: {
                    size: 10
                },
                callbacks: {
                    title: function (context) {
                        return context[0].dataset.label;
                    },
                    label: function () {
                        return '';
                    }
                }
            },
            datalabels: {  // Disable data labels
                display: false
            }
        }
    };

    return (
        <div className="lab-analysis-section-content-container">
            <h2 className="lab-analysis-section-title">Cost of Doing the Work</h2>
            <div className="lab-analysis-financial-data-container">
                <LabAnalysisOverviewCosts simulatorData={simulatorData} />
                <CurlyBraceDivider color='red' />
                <div className="lab-analysis-costs-chart-container">
                    <Scatter data={scatterData} options={options} />
                </div>
            </div>
            <p className="lab-analysis-costs-intro-text text-align-center" dangerouslySetInnerHTML={{ __html: introText }} />
        </div>
    );
};

export default LabAnalysisCosts;